//import React, {Component} from 'react';
import React from 'react';
import PropTypes from 'prop-types';
//import { withStyles } from '@material-ui/core/styles';
import {withStyles} from "@material-ui/core";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
//import Icon from '@material-ui/core/Icon';
//import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
//import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Tooltip from '@material-ui/core/Tooltip';
import Popover from '@material-ui/core/Popover';
import NavigationIcon from '@material-ui/icons/Navigation';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import Grid from "@material-ui/core/Grid";
import GridList from '@material-ui/core/GridList';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';


/* const styles = {


};*/

const styles = theme => ({
    margin: {
        margin: theme.spacing.unit * 2,
    },
    extendedIcon: {
        marginRight: theme.spacing.unit * 8,
    },
    regularIcon: {
        marginRight: theme.spacing.unit * 1,
    },
    card: {
        //maxWidth:500,
        //backgroundColor:'#c9e5f5',
        backgroundColor:'#f2ede4',
        borderWidth:2,
        borderColor:'black',
        marginBottom:'10px'
    },
    gridList: {
        width: 400,
        height:400,
    },
    
});


//'url(' + require('../../images/IMG_1.JPG')
class CardPrivatePropertyVehicleInformation extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            age: '',
            name: 'Farshid',
            testnumber: '1232322',
            labelWidth: 0,
            open:false,
            isInEditMode:false,
        };
        //const unsubscribe = store.subscribe( () => {/*console.log(store.getState())*/});
        this.deleteImageClick = this.deleteImageClick.bind(this);
        this.editImageClick = this.editImageClick.bind(this);
        this.handleClickOpen = this.handleClickOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.PaperComponent = this.PaperComponent.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.setEditMode = this.setEditMode.bind(this);
        
        
    }
    
    
    deleteImageClick(argData){
        
        //alert('delete was 1 called');
        // this.props.onDelete(argData.id);
        this.setState({ open: true });
        
        
    }
    
    /*
    private String id;
	private String model;
	private String make;
	private String year;
	private String color;
	private String platenumber;
	private String state;
	private String verificationStatus;
	private String vin ;
	private Date createdDate;
	private Date modifiedDate;
	private Date endDate;

     */
    
    editImageClick(argData){
        
        //this.setState({isInEditMode:true});
        this.props.info.editMode==true;
        this.props.onEdit(argData);
        
    }
    setEditMode(argValue){
        this.props.info.editMode=argValue;
        this.setState({isInEditMode:argValue});
    }
    
    handleClickOpen(){
        this.setState({ open: true });
    };
    
    handleClose(){
        this.setState({ open: false });
    };
    
    handleDelete(){
        this.props.onDelete(this.props.info.id);
        this.setState({ open: false });
    };
    
    PaperComponent(props) {
        return (
          <Draggable cancel={'[class*="MuiDialogContent-root"]'}>
              <Paper {...props} />
          </Draggable>
        );
    }
    
    componentDidMount(){
        if(!this.props.info.editMode){
            this.setState({ isInEditMode: false });
        }else{
            this.setState({ isInEditMode: true });
        }
    }
    
    render() {
        const {classes} = this.props;
        // const classes2 = useStyles();
        let vipText = "No";
        if(this.props.info.vip == "Yes"){
            vipText="Yes"
        }
        return (
          <div>
              < Card className = {classes.card} style={{backgroundColor:this.props.info.editMode ? 'white' : '\'#cfd0fa\''}}  elevation={3} raised={true}>
                  < CardActionArea >
                      < CardContent >
                          <Grid container spacing={24}>
                              {/*
                                <Grid item xs={2} sm={2}>
                                    <DriveEtaIcon fontSize="large" color="primary"></DriveEtaIcon>
                                </Grid>
                                <Grid item xs={10} sm={10}>
                                      <div>
                                            < Typography  style={{display: 'inline-block'}}
                                                variant = "h6" >
                                                    Community Vehicle
                                            < /Typography>
                                        </div>
                                </Grid>
                                */}
                              
                              <Grid item xs={6} sm={6}>
                                  < Typography  style={{display: 'inline-block' , marginLeft: 5}}
                                                variant = "body2"
                                  >
                                      {this.props.info.platenumber}
                                  < /Typography>
                              </Grid>
                              
                              
                              <Grid item xs={6} sm={6}>
                                  < Typography  style={{display: 'inline-block' , marginLeft: 5}}
                                                variant = "body2"
                                  >
                                      {this.props.info.state}
                                  < /Typography>
                              </Grid>
                              
                              <Grid item xs={6} sm={6}>
                                  < Typography  style={{display: 'inline-block' , marginLeft: 5}}
                                                variant = "body2" >
                                      {this.props.info.year}
                                  < /Typography>
                              </Grid>
                              <Grid item xs={6} sm={6}>
                                  < Typography  style={{display: 'inline-block', marginLeft: 5}}
                                                variant = "body2" >
                                      {this.props.info.make}
                                  < /Typography>
                              </Grid>
                              <Grid item xs={6} sm={6}>
                                  
                                  < Typography  style={{display: 'inline-block' , marginLeft: 5}}
                                                variant = "body2" >
                                      {this.props.info.model}
                                  < /Typography>
                              </Grid>
                              
                              <Grid item xs={6} sm={6}>
                                  < Typography  style={{display: 'inline-block' , marginLeft: 10}}
                                                variant = "body2" >
                                      {this.props.info.color}
                                  < /Typography>
                              </Grid>
                              
                              
                              <Grid item xs={6} sm={6}>
                                  < Typography  style={{display: 'inline-block' , marginLeft:5}}
                                                variant = "body2" >
                                      {this.props.info.vin}
                                  < /Typography>
                              </Grid>
                              <Grid item xs={1} sm={1}>
                              
                              </Grid>
                              <Grid item xs={3} sm={3}>
                                  < Typography  style={{display: 'inline-block' , marginLeft: 10}}
                                                variant = "body2" >
                                      VIP: {vipText}
                                  < /Typography>
                              </Grid>
                              <Grid item xs={1} sm={1}>
                              
                              </Grid>
                              <Grid item xs={1} sm={1}>
                                  <DeleteIcon  color="secondary"onClick={() =>this.deleteImageClick(this.props.info)}/>
                              </Grid>
                          
                          
                          </Grid>
                      < /CardContent>
                  < /CardActionArea>
                  {/*}
            < CardActions >
                <Tooltip title="Delete" aria-label="Delete">
                    <IconButton color="secondary" aria-label="delete" className={classes.extendedIcon}>
                    <DeleteIcon fontSize="large" onClick={() =>this.deleteImageClick(this.props.info)}/>
                    </IconButton>

                    </Tooltip>
                 


            < /CardActions>
            */}
              < /Card>
              
              
              <Dialog
                open={this.state.open}
                onClose={this.handleClose}
                PaperComponent={this.PaperComponent}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                  <DialogTitle id="alert-dialog-title">{"Do you want to remove a vehicle?"}</DialogTitle>
                  <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                          This Vehicle with the Plate Number {this.props.info.platenumber} and Model  {this.props.info.model} will be removed from your profile.
                      </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                      <Button onClick={this.handleClose} color="primary">
                          Cancel
                      </Button>
                      <Button onClick={this.handleDelete} color="primary" autoFocus>
                          Delete
                      </Button>
                  </DialogActions>
              </Dialog>
          
          </div>
        )
          ;
    }//end of render
}//End of class

CardPrivatePropertyVehicleInformation.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CardPrivatePropertyVehicleInformation);
